import { render, staticRenderFns } from "./ThreadForm.vue?vue&type=template&id=7f29caa2&scoped=true"
import script from "./ThreadForm.vue?vue&type=script&lang=js"
export * from "./ThreadForm.vue?vue&type=script&lang=js"
import style0 from "./ThreadForm.vue?vue&type=style&index=0&id=7f29caa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f29caa2",
  null
  
)

export default component.exports